import { render, staticRenderFns } from "./TopLeftCmp.vue?vue&type=template&id=0838ebd2&scoped=true"
import script from "./TopLeftCmp.vue?vue&type=script&lang=js"
export * from "./TopLeftCmp.vue?vue&type=script&lang=js"
import style0 from "./TopLeftCmp.vue?vue&type=style&index=0&id=0838ebd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838ebd2",
  null
  
)

export default component.exports